import { useEffect, useContext } from 'react'
import { ImperialBookingContext } from '../context/ImperialBookingContext'
import useApiRequest from './useApiRequest'
import { isArray, cloneDeep } from 'lodash-es'

const dateSort = (a, b) => {
  return (new Date(a.date)).getTime() - (new Date(b.date)).getTime()
}

const useBookings = (fetchOnMount = false, filterFunc = undefined) => {
  const { bookings, setBookings, bookingsLoaded, setBookingsLoaded } = useContext(ImperialBookingContext)
  const { apiGet, apiPost, apiPut } = useApiRequest()

  const fetchBookings = (bookingId = null) => {
    const path = !!bookingId ?  `bookings/${bookingId}` : 'bookings'
    return apiGet(path)
      .then((data) => {
        try {
          if (isArray(data)) {
            setBookings(data.sort(dateSort))
            setBookingsLoaded(true)
          } else {
            const bIndex = bookings.findIndex(b => b.id === bookingId)
            bookings[bIndex] = data
            setBookings(cloneDeep(bookings))
          }
        } catch (e) {
          console.log('error', e)
        }
      })
      .catch((err) => {
        console.log('caught', err)
        setBookings([])
        throw err
      })
  }

  const createBooking = (date, notes, title, officialUse, officialUseZoom) => {
    const payload = { date, notes, title, official_use: officialUse, official_use_zoom: officialUseZoom }
    return apiPost(`bookings`, payload)
  }

  const updateBooking = (bookingId, payload) => {
    return apiPut(`bookings/${bookingId}`, payload)
  }

  useEffect(() => {
    if (!bookings || fetchOnMount) {
      fetchBookings()
    }
  }, [])

  return {
    bookings: (bookings && filterFunc) ? bookings.filter(filterFunc) : bookings,
    refreshBookings: fetchBookings,
    createBooking,
    updateBooking,
    bookingsLoaded,
  }
}

export default useBookings
